<template>
  <div class="app-f-project">
    <el-select
      :value="projectId"
      :disabled="setDisable()"
      class="app-project-select"
      size="small"
      popper-class="app-project-options g-select-opts"
      @change="onProjChange"
    >
      <el-option
        v-for="item in projects"
        :key="item.id"
        :label="item.name"
        :value="item.id"
      >
      <div class="option-text truncate">{{ item.name }}</div>
      <div class="option-icon" @click.stop="handleToTop(item)"><zhitu-icon icon="top"/></div>
      </el-option>
    </el-select>
    <span class="app-f-project-hr">|</span>
    <div
      class="app-f-project-item"
      :class="{ active: routerName === 'template' }"
      @click="handleRoute('template')"
    >
      项目模板
    </div>
    <div
      class="app-f-project-item"
      :class="{
        active:
          ['material-img', 'material-bg-img', 'material-bg-color'].indexOf(
            routerName
          ) > -1
      }"
      @click="handleRoute('material')"
    >
      项目素材
    </div>
  </div>
</template>
<script>
import util from '@/util.js'
import userService from '@/request/service/user-service'
import { mapActions } from 'vuex'
export default {
  data () {
    return {
      routerName: this.$route.name
    }
  },
  computed: {
    projectId () {
      return this.$store.state.app.projectId
    },
    projects () {
      return this.$store.state.app.projects
    }
  },
  created () {
    this.queryLoginUserProjects()
  },
  methods: {
    ...mapActions({
      queryLoginUserProjects: 'app/queryLoginUserProjects'
    }),
    setDisable () {
      return this.$route.path.indexOf('admin') > -1
      // return this.projects.length < 2 || this.$route.path.indexOf('admin') > -1
    },
    handleToTop (item) {
      const { id } = item
      userService.setTopProject(id).then(() => {
        this.queryLoginUserProjects()
      })
    },
    redirectToHome () {},
    onProjChange (v) {
      util.setStorageProjectId(v)
      this.$store.commit('app/set_active_project', v)
      let pageName = this.$route.meta.userActionKey
      this.saveUserAction(pageName, this.ActionType.project.switch.key)
      if (v) {
        let user = this.$store.state.app.loginUser
        if (user.role) {
          this.$store.commit('app/set_active_project_role', user.role)
        } else {
          let projects = this.$store.state.app.loginUser.projectRoles
          let projectRole = projects.find(item => {
            return item.projectId === v
          })
          let role = projectRole ? projectRole.role : ''
          this.$store.commit('app/set_active_project_role', role)
        }
        if (this.$route.path.indexOf('admin') > -1) {
          this.$router.push({ name: 'template', query: { projectId: v } })
        } else {
          this.$router.push({
            name: 'template',
            query: Object.assign({}, this.$route.query, { projectId: v })
          })
        }
      }
    },
    handleRoute (routerName) {
      this.$router.push(`/${routerName}`)
    }
  }
}
</script>
<style lang="scss">
$headerPrjHeight: 32px;
.app-f-project {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 312px;
  height: $headerPrjHeight;
  padding-right: 16px;
  border-radius: 23px;
  margin-left: 25px;
  background: #f8f8f8;
  box-sizing: border-box;
  overflow: hidden;
  .app-project-select {
    width: 140px;
    height: $headerPrjHeight;
    .el-input {
      height: $headerPrjHeight;
      line-height: $headerPrjHeight;
      vertical-align: middle;
      input {
        width: 100%;
        padding-left: 16px;
        font-size: 14px;
        font-weight: 500;
        border: 0px;
        color: #323337;
        background: #f8f8f8;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
  .is-disabled {
    .el-input__suffix {
      display: none;
    }
  }
  .app-proj-icon {
    line-height: normal;
    position: absolute;
    top: 17px;
    left: 12px;
    font-size: 18px;
    z-index: 1;
  }
  .app-f-project-hr {
    color: #d0d0d1;
  }
  .app-f-project-item {
    flex: 1;
    width: 0;
    height: $headerPrjHeight;
    line-height: $headerPrjHeight;
    font-weight: 500;
    text-align: center;
    color: #323337;
    cursor: pointer;
    &.active {
      color: #3366ff;
    }
  }
}
.app-project-options {
  width: 190px;
  &.el-select-dropdown {
    &.el-popper[x-placement^="bottom"] {
      margin-top: 8px;
    }
    .popper__arrow {
      display: inline-block;
    }
    .el-select-dropdown__item {
      display: flex;
      width: 100%;
      padding: 0 16px;
      &:first-child {
        .option-icon {
          display: none !important;
        }
      }
      &:hover {
        .option-icon {
          display: flex;
        }
      }
      .option-text {
        flex: 1;
        width: 0;
      }
      .option-icon {
        width: 24px;
        margin-left: 10px;
        // display: flex;
        align-items: center;
        display: none;
        cursor: pointer;
        .zhitu-icon {
          width: 24px;
          height: 24px;
          padding: 5px;
          background: transparent;
          border-radius: 4px;
          &:hover {
            background: #E0E0E0;
          }
        }
      }
    }
  }
}
</style>
